// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const remoraid: PokeData = {
  "id": 223,
  "name": "remoraid",
  "height": 6,
  "weight": 120,
  "base_experience": 60,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "water-gun",
    "hydro-pump",
    "ice-beam",
    "psybeam",
    "bubble-beam",
    "aurora-beam",
    "hyper-beam",
    "focus-energy",
    "bubble",
    "lock-on",
    "helping-hand",
    "signal-beam",
    "bullet-seed",
    "water-pulse",
    "charge-beam",
    "soak",
    "acid-spray"
  ],
  "moves": [
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "bullet-seed",
    "liquidation",
    "whirlpool",
    "aqua-cutter",
    "aqua-tail",
    "life-dew",
    "aqua-jet",
    "rain-dance",
    "water-spout",
    "brine"
  ],
  "evolution_chain": {
    "id": 114,
    "item": null,
    "species": [
      {
        "name": "remoraid",
        "order": 255,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "octillery",
        "order": 256,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 223,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 35,
    "speed": 65,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
